/**
 * 导出所有api 模块下的地址
 */

const modulesFiles = require.context("./apis", true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const value = modulesFiles(modulePath)
  modules = Object.assign(modules, value.default)
  return modules
}, {})
export default modules


// WEBPACK FOOTER //
// ./src/api/index.js